import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'tax-cto-status',
  templateUrl: './cto-status.component.html',
  styleUrls: ['./cto-status.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class CtoStatusComponent {
  // @ts-ignore
  @Input() status: number;
  // @ts-ignore
  @Input() createdAt: number;
  // @ts-ignore
  @Input() updatedAt: number;
  // @ts-ignore
  @Input() endsAt: number;
}
